import { AlertCircle } from 'lucide-react';

const BookingZone = ({ embedHtml, placeholder = "Zone de réservation" }) => {
  if (!embedHtml || embedHtml.trim() === '') {
    return (
      <div 
        className="embed-zone flex flex-col items-center justify-center text-center py-12"
        data-testid="booking-zone-empty"
      >
        <AlertCircle className="w-12 h-12 text-stone-300 mb-4" />
        <p className="text-stone-500 font-medium">{placeholder}</p>
        <p className="text-stone-400 text-sm mt-1">
          Le formulaire de réservation sera bientôt disponible
        </p>
      </div>
    );
  }

  // Modify iframe to be responsive with larger height
  const responsiveHtml = embedHtml
    .replace(/width="[^"]*"/g, 'width="100%"')
    .replace(/height="[^"]*"/g, 'height="1100"')
    .replace(/<iframe/g, '<iframe style="border:none;min-height:1000px;max-width:100%;" scrolling="auto"');

  return (
    <div 
      className="booking-zone w-full"
      data-testid="booking-zone"
    >
      <style>
        {`
          .booking-zone iframe {
            width: 100% !important;
            min-height: 1000px !important;
            height: 1100px !important;
            border: none !important;
          }
          @media (max-width: 640px) {
            .booking-zone iframe {
              min-height: 1100px !important;
              height: 1200px !important;
            }
          }
        `}
      </style>
      <div 
        className="w-full"
        dangerouslySetInnerHTML={{ __html: responsiveHtml }}
      />
    </div>
  );
};

export default BookingZone;
